import { useContext } from 'react';

import { WalletConnectStateContext } from '../contexts/wallet-connect-state';

export const useWalletConnect = () => {
  return useContext(WalletConnectStateContext);
};
